import { render } from "./Programme.vue?vue&type=template&id=650c7ea8"
import script from "./Programme.vue?vue&type=script&lang=js"
export * from "./Programme.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__